<div class="profile-container">
    <div class="user-info-section">
        <div class="name-container">{{name}}</div>
        <div class="email-container">{{email}}</div>
    </div>
    <div class="divider"></div>
    <div *ngIf="isAllowedAccountDropdown" class="account-select-section">
        <div class="view-as-label">View as</div>
        <app-select-menu [control]="selectedAccount" [items]="accountOptions" [searchable]="true" (onApply)="selectAccount()"
                         [selectMode]="SelectMode.SINGLE" [dropDownPosition]="'top'" [arrowIcon]="'svg/Polygon.svg'"></app-select-menu>
    </div>
    <div *ngIf="isAllowedAccountDropdown" class="divider"></div>
    <div *ngIf="isAllowedManageAccounts" class="manage-accounts-container" (click)="goToManageScreen()">Management</div>
    <div *ngIf="isAllowedManageAccounts" class="divider"></div>
    <div data-testid="side-menu-logout-button" class="log-out-container" (click)="logOut()">Log out</div>
</div>
